import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useReport } from '../../../DataStore/ReportContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxReport from '../../../util/remote/ajaxReport';



const initialValues = {
  reportTitle: '',
  reportDate: '',
};

const NewReport = () => {
  const [formValues, setFormValues] = useReducer((curr, next) => ({ ...curr, ...next }), initialValues);
  const [notify, setNotify] = useState(null);
  const [classId, setClassId] = useState('');
  const [term, setTerm] = useState('');
  const [reportFormat, setReportFormat] = useState('');
  const [primaryScale, setPrimaryScale] = useState('');
  const [advancedScale, setAdvancedScale] = useState('');
  const [loading, setLoading] = useState(false);

  const { reportTitle, reportDate } = formValues;

  const {
    reportFormats,
    primaryScales,
    advancedScales,
    academicTerms,
    classes,
    assessmentList,
    getClasses,
    getAcademicTerms,
    getReportFormats,
    getPrimaryScales,
    getAdvancedScales,
    getAssessments
  } = useConfig();
  const { selectedTests, setSelectedTests, setReportTest, getReports } = useReport();

  useEffect(() => {
    getClasses();
    getAcademicTerms();
    getReportFormats();
    getPrimaryScales();
    getAdvancedScales();
    getAssessments();
  }, []);

  useEffect(() => {
    if (notify) {
      const timeout = setTimeout(() => setNotify(null), 5000);
      return () => clearTimeout(timeout);
    }
  }, [notify]);

  const handleSave = async (e) => {
        e.preventDefault();
        if(loading){
            return;
        }
        
        if(!classId.value || !term.value || !reportFormat.value || !primaryScale.value){
            setNotify(<Notification type='danger' message="Complete all fields and try again"/>);
            return false;
        }

        const data ={
            class_id: classId.value,
            report_date: reportDate,
            term_id: term.value,
            title: reportTitle,
            tests: selectedTests,
            report_format: reportFormat.value,
            primary_scale: primaryScale.value,
            advanced_scale: advancedScale.value || '0'
        }
        
       
        if(selectedTests.length===0){
            setNotify(<Notification type='danger' message={"Add report exams and try again."}/>);
            return false;
        }
        setLoading(true);
        setNotify(null);
        const server_response = await ajaxReport.createReport(data);
        setLoading(false);
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            setFormValues(initialValues);
            getReports(true);
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

      
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ [name]: value });
  };

  const renderSelectInput = (label, options, onChange, placeholder, required = false) => (
    <TextInput
      label={label}
      type="select"
      options={options}
      onChange={(item) => onChange(item)}
      placeholder={placeholder}
      wrap
      required={required}
    />
  );

  const mapOptions = (data, labelFn, valueKey) =>
    Array.isArray(data) ? data.map((item) => ({ label: labelFn(item), value: item[valueKey] })) : [];

  const handleRemoveTest = (testId) => {
    const updatedTests = selectedTests.filter(test => test.test_id !== testId);
    setSelectedTests(updatedTests);
  }

  return (
    <div className="card-body">
      <CallOut
        title="New Report"
        description="Create Academic Reports. Only students appearing in the marksheet will be considered in the new report."
      />
      {notify}
      <form className="form-horizontal" onSubmit={handleSave}>
        {renderSelectInput('Report Format', mapOptions(reportFormats, item => `${item.format_name} (${item.description})`, 'format_id'), setReportFormat, 'Select format...', true)}
        {renderSelectInput('For Class', mapOptions(classes, item => item.class_name, 'class_id'), setClassId, 'Select class...', true)}

        <TextInput
          label="Report Title"
          name="reportTitle"
          type="text"
          value={reportTitle}
          onChange={handleChange}
          placeholder="Report Title"
          wrap
          required
        />

        <TextInput
          label="Report Date"
          name="reportDate"
          type="date"
          value={reportDate}
          onChange={handleChange}
          placeholder="Report Date"
          wrap
          required
        />

        {renderSelectInput('For Term', mapOptions(academicTerms, item => item.term, 'term_id'), setTerm, 'Select term...', true)}
        {renderSelectInput('Report Exams', mapOptions(assessmentList, item => item.exam_name, 'id'), setReportTest, 'Select exam...', false)}
        {renderSelectInput('Primary Scale', mapOptions(primaryScales, item => item.title, 'scale_id'), setPrimaryScale, 'Select primary scale...', true)}
        {renderSelectInput('Advanced Scale', mapOptions(advancedScales, item => `${item.scale_name} (${item.description})`, 'scale_id'), setAdvancedScale, 'Select advanced scale...', false)}

        {Array.isArray(selectedTests) && (
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Exam Check List</h3>
            </div>
            <div className="card-body p-0">
              <ul className="nav nav-pills flex-column">
                {selectedTests.map((item, idx) => (
                  <li className="nav-item" key={idx}>
                    <div className="icheck-primary ml-4">
                      <input type="checkbox" id={`tests-${item.test_id}`} checked readOnly onClick={()=>handleRemoveTest(item.test_id)} />&nbsp;
                      <label htmlFor={`tests-${item.test_id}`} className="checklist-link">
                        {item.exam_name} <span id={`${item.test_id}-out-of`}>/ {item.out_of}</span>
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className="text-right mt-3">
          {!loading ? (
            <button type="submit" className="btn btn-lg btn-success">Save Report</button>
          ) : (
            <ActivityLoader />
          )}
        </div>
      </form>
    </div>
  );
};

export default NewReport;
